import { createAction, props } from "@ngrx/store";
import { StandingInstruction } from "../../shared/types/StandingInstruction";
import { transactionTypes, ViewTypes } from "../../shared/utilities/Constants";
import { CashieringTransaction, RecurringTransaction } from "../models";
import { AchAcknowledgeApiResponse } from "../models/ach/AchAcknowledgeApiResponse";
import { AchInputResponse } from "../models/ach/AchInputApiResponse";
import { AchInquiryResponse } from "../models/ach/AchInquiryResponse";
import { AchVerifyApiResponse } from "../models/ach/AchVerifyApiResponse";
import { ServiceError, ServiceErrorWithList } from "../models/shared/ServiceError";

export const callAchInput = createAction(
    '[Create Request - ACH] Call to AchInput',
    props<{authorizationUniqueId: string}>()
);

export const inputCallSuccessful = createAction(
    '[Create Request - ACH] Call to input succeeded',
    props<{ achInfo: AchInputResponse}>()
);

export const inputCallFailed = createAction(
    '[Create Request - ACH] Call to input failed',
    props<ServiceError>()
);

export const verifyCallSuccessful = createAction(
    '[Create Request - ACH] Call to verify was successful',
    props<{response: AchVerifyApiResponse, initiationDate: string}>()
);

export const verifyCallFailed = createAction(
    '[Create Request - ACH] Error calling verify',
    props<ServiceErrorWithList>()
);

export const callAcknowledge = createAction(
    '[Create Request - ACH] Call to ACH acknowledge'
);

export const callAddProfileAcknowledge = createAction(
    '[Create Request - ACH] Call to ACH add profile acknowledge'
);

export const acknowledgeCallSuccessful = createAction(
    '[Create Request - ACH] Call to ACH acknowledge was successful',
    props<{ response: AchAcknowledgeApiResponse }>()
);

export const acknowledgeCallFail = createAction(
    '[Create Request - ACH] Call to ACH acknowledge failed',
    props<ServiceErrorWithList>()
);

export const callInquiry = createAction(
    '[Create Request - ACH] Call to ACH inquiry',
    props<{ payload: StandingInstruction | CashieringTransaction | RecurringTransaction, viewType: ViewTypes, transactionType: transactionTypes }>()
);

export const inquiryCallSuccessful = createAction(
    '[Create Request - ACH] Call to ACH inquiry was successful ',
    props<{ achInquiryResponse: AchInquiryResponse }>()
);

export const inquiryCallFailed = createAction(
    '[Create Request - ACH] Call to ACH inquiry failed',
    props<ServiceError>()
);

export const resetTaxWithholdingsToDefault = createAction(
    '[Create Request - ACH] Reset tax withholdings to default values'
);

export const deleteProfileFromReviewPageSuccessful = createAction(
    '[Create Request - ACH] Delete On-Request ACH Profile from Review page was successful'  
);